import { ArrowRightOutlined } from '@ant-design/icons';
import {
  actionButtons,
  farmStagesTitles,
} from 'constants/FarmboxConstants/stage0.constants';
import { ButtonType } from 'enums/ButtonEnums';
import { FuelAndEnergyDetails } from 'models/Farmbox/fuelAndEnergy.model';
import React, { useContext, useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import { useParams, useSearchParams } from 'react-router-dom';
import FarmFuelAndEnergyService from 'services/FarmFuelAndEnergyService/farmFuelAndEnergy.service';
import CardWithStickyHeader, {
  ButtonProps,
} from 'shared/components/CardWithStickyHeader';
import styles from './farmFuelAndEnergyFlow.module.scss';
import FieldsRow from 'shared/components/FieldsRow';
import { FormType } from 'enums/FieldTypeEnums';
import {
  getFuelAndEnergyFarmFormFields,
  getFuelAndEnergyScopeFormFields,
} from './stage3FarmData';
import useFarmboxRedirections from 'shared/utils/useFarmboxRedirections';
import isProductDisabled from 'shared/utils/isProductDisabled';
import { HelpDeskContext } from 'context/HelpDeskContext';

const FarmFuelAndEnergy = () => {
  const {
    loading,
    updateFuelAndEnergyDataAsDraft,
    fetchFuelAndEnergyData,
    buttonLoading,
  } = FarmFuelAndEnergyService();
  const { id: commodityId, status } = useParams();
  const { handleSubmit, reset } = useFormContext<FuelAndEnergyDetails>();
  const { setIsHelpDeskOpen } = useContext(HelpDeskContext);
  const [searchParams] = useSearchParams();
  const queryParams = Object.fromEntries(searchParams.entries());
  const { redirectToFarmField, redirectToFarmTransportation } = useFarmboxRedirections();

  useEffect(() => {
    fetchFuelAndEnergyResponse();
  }, []);

  const fetchFuelAndEnergyResponse = async () => {
    const fuelAndEnergyData = await fetchFuelAndEnergyData({ commodityId });
    // for reset the default values of form
    const defaultValues =
      fuelAndEnergyData?.commodity || fuelAndEnergyData?.location
        ? { ...new FuelAndEnergyDetails(), ...fuelAndEnergyData }
        : new FuelAndEnergyDetails();

    reset(defaultValues);
  };

  const { FUEL_AND_ENERGY } = farmStagesTitles;
  const { PRIMARY } = ButtonType;
  const { NEXT } = actionButtons;
  const { REACT_HOOK_FORMS } = FormType;
  const isDisabled = isProductDisabled(status);

  const handleFormSubmit = async () => {
    if (!isDisabled) {
      const isSuccess = await updateFuelAndEnergyDataAsDraft(commodityId);
      if (isSuccess)
        redirectToFarmField(Number(commodityId), status, queryParams);
    } else {
      redirectToFarmField(Number(commodityId), status, queryParams);
    }
  };

  const actionButton: ButtonProps[] = [
    {
      icon: <ArrowRightOutlined />,
      title: NEXT,
      clickCallback: () => {
        handleSubmit(handleFormSubmit)();
      },
      type: PRIMARY,
      submit: true,
      loading: buttonLoading,
    },
  ];

  const handleBackNavigation = () => {
    setIsHelpDeskOpen(false);
    redirectToFarmTransportation(Number(commodityId), status, queryParams);
  };

  return (
    <div className={styles.scopeContainer}>
      <div className={styles.scopeCardContainer}>
        <CardWithStickyHeader
          title={FUEL_AND_ENERGY}
          actionButtons={actionButton}
          backCallback={handleBackNavigation}
          loading={loading}>
          <form onSubmit={handleSubmit(handleFormSubmit)}>
            <div className={styles.scopeHeaderContainer}>
              <div className={styles.contentContainer}>
                <div className={styles.scopeRow}>
                  <div className={styles.formFieldsContainer}>
                    <FieldsRow
                      {...getFuelAndEnergyFarmFormFields()}
                      formType={REACT_HOOK_FORMS}
                    />
                  </div>
                </div>
                <div className={styles.scopeRow}>
                  <div className={styles.formFieldsContainer}>
                    <FieldsRow
                      {...getFuelAndEnergyScopeFormFields()}
                      formType={REACT_HOOK_FORMS}
                    />
                  </div>
                </div>
              </div>
            </div>
          </form>
        </CardWithStickyHeader>
      </div>
    </div>
  );
};

export default FarmFuelAndEnergy;
